import { render, staticRenderFns } from "./BidEdit.vue?vue&type=template&id=0aa4a0ce"
import script from "./BidEdit.vue?vue&type=script&lang=js"
export * from "./BidEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports